const data = {
    activeTags: [],
}

export default data